// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__CMJeN","fadeIn":"Modal_fadeIn__5ool7","fadeOut":"Modal_fadeOut__sYrAv","withHeader":"Modal_withHeader__NhlbR","withFooter":"Modal_withFooter__-68tq"};